
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionTemplateGrid extends Serenity.EntityGrid<QualityInspectionTemplateRow, any> {
        protected getColumnsKey() { return 'Administration.QualityInspection'; }
        protected getDialogType() { return QualityInspectionTemplateDialog; }
        protected getIdProperty() { return QualityInspectionTemplateRow.idProperty; }
        protected getInsertPermission() { return QualityInspectionTemplateRow.insertPermission; }
        protected getLocalTextPrefix() { return QualityInspectionTemplateRow.localTextPrefix; }
        protected getService() { return QualityInspectionTemplateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}